"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_GROUP = exports.ABExperimentName = void 0;
// Must be UPPER_SNAKE_CASE format, will be enforced by tests
// These experiment names will be complied into the client bundle so that they should not include sensitive information
var ABExperimentName;
(function (ABExperimentName) {
    ABExperimentName["PRELOAD_TASTY_BYTES"] = "PRELOAD_TASTY_BYTES";
    ABExperimentName["REMAINING_FREE_USAGE_TRIAL_CARD_LOCATION"] = "REMAINING_FREE_USAGE_TRIAL_CARD_LOCATION";
    ABExperimentName["SIGNUP_FORM_REWORK_COREUI_COUNTRY_SELECTOR"] = "SIGNUP_FORM_REWORK_COREUI_COUNTRY_SELECTOR";
    ABExperimentName["SANITY_AA_TEST"] = "SANITY_AA_TEST";
    ABExperimentName["INVITE_USER"] = "INVITE_USER";
    ABExperimentName["FEATURED_TEMPLATES"] = "FEATURED_TEMPLATES";
    ABExperimentName["TEMPLATES_CMS"] = "TEMPLATES_CMS";
    ABExperimentName["MODIFIED_SIGNUP_FLOW"] = "MODIFIED_SIGNUP_FLOW";
    ABExperimentName["REDUCED_WAREHOUSE_AUTOSUSPEND"] = "REDUCED_WAREHOUSE_AUTOSUSPEND";
    ABExperimentName["OIDC_SIGNUP_GOOGLE"] = "OIDC_SIGNUP_GOOGLE";
    ABExperimentName["OIDC_SIGNUP_MICROSOFT"] = "OIDC_SIGNUP_MICROSOFT";
    ABExperimentName["BILLING_PEP_MIGRATION"] = "BILLING_PEP_MIGRATION";
})(ABExperimentName || (exports.ABExperimentName = ABExperimentName = {}));
exports.DEFAULT_GROUP = 'DEFAULT';
//# sourceMappingURL=experiments.js.map